import getSymbolFromCurrency from 'currency-symbol-map';
import { useMemo } from 'react';

/**
 * Hook to get a currency symbol by code
 * @param currencyCode - ISO 4217 currency code (e.g. "USD", "EUR", "BTC")
 * @returns the symbol (e.g. "$", "€", "₿") or the code if not found
 */
export function useCurrencySymbol(currencyCode?: string) {
    const symbol = useMemo(() => {
        if (!currencyCode) return '';
        return getSymbolFromCurrency(currencyCode) || currencyCode;
    }, [currencyCode]);

    return symbol;
}
